import React from 'react'
import { Link } from 'react-router-dom';
import ProductDetailsContent from '../../../components/Dashboard/ProductsListContent/View';

function ProductDetails() {
    return (
        <>
          {/* Breadcrumb */}
          {/* <div className="breadcrumb-card">
            <h5>Products </h5>
    
            <ul className="breadcrumb">
              <li>
                <Link to="/dashboard/ecommerce/">
                  <i className="material-symbols-outlined">home</i>
                  Dashboard
                </Link>
              </li>
              <li>Products List</li>
              <li>Product Details</li>
            </ul>
          </div> */}
           
          <ProductDetailsContent />
        </>
      );
}

export default ProductDetails 
